<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="planningScenario.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Описание</label>
            <crm-editor
              [(value)]="planningScenario.description"
              height="250px"></crm-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div
            *ngIf="planningScenario['deleted']"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удален"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="savePlanningScenario()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !planningScenario['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deletePlanningScenario()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && planningScenario['deleted']"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restorePlanningScenario()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>

<p-dialog
  header="Удаление сценарии планирования"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="showChangePlanningScenarioDialog"
  [style]="{ width: '400px' }"
  (onHide)="selectPlanningScenario = null">
  <ng-container *ngIf="!loadingChangePlanningScenario; else loadingChangePlanningScenarioTemplate">
    <p class="mb-3">Выберите сценарий планирования, на который вы желаете заменить все заявки с текущим сценарием</p>

    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Сценарий планирования</label>
        <crm-planning-scenario-single-select
          [(selectedEntity)]="selectPlanningScenario"
          [excludeIds]="excludePlanningScenarioIds"
          appendTo="body"></crm-planning-scenario-single-select>
      </div>
    </div>

    <div class="mt-3">
      <crm-button
        label="Удалить"
        [disabled]="!selectPlanningScenario"
        styleClass="p-button-success"
        (onClick)="delegateTo()"></crm-button>
    </div>
  </ng-container>

  <ng-template #loadingChangePlanningScenarioTemplate>
    <crm-spinner top="mt-2 pt-2"></crm-spinner>
  </ng-template>
</p-dialog>
